import React from "react";
import RightPanel from "../../components/RightPanel/RightPanel";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";

export const EditorRightPanelSection = () => {
  const ctx = useEditorMainPageContext();

  const parentScrollbarForSelection = ctx.editComponent
    ? ctx.layerCompData?.find(
        (comp) =>
          comp.componentType === "Scrollbar" &&
          comp.id === ctx.editComponent?.id,
      )
    : null;

  const rhsLayerCompData = ctx.editComponent
    ? ctx.scrollbarItems?.length
      ? ctx.scrollbarItems
      : parentScrollbarForSelection?.scrollbarComponents || ctx.layerCompData
    : ctx.layerCompData;

  const rhsSetLayerCompData = ctx.editComponent
    ? ctx.setScrollbarItems
    : ctx.setLayerCompData;

  return (
    <RightPanel
      triggerUndoCapture={() => ctx.setRhsUpdateTrigger((prev) => prev + 1)}
      rhsUpdateTrigger={ctx.rhsUpdateTrigger}
      setRhsUpdateTrigger={ctx.setRhsUpdateTrigger}
      updateMultiCompProperties={ctx.updateMultiCompProperties}
      updatedValue={ctx.updatedValue}
      setUpdatedValue={ctx.setUpdatedValue}
      multiSelectedComps={ctx.multiSelectedComps}
      setMultiSelectedComps={ctx.setMultiSelectedComps}
      multiSelect={ctx.multiSelect}
      setMultiSelect={ctx.setMultiSelect}
      isAspectRatioLocked={ctx.isAspectRatioLocked}
      setIsAspectRatioLocked={ctx.setIsAspectRatioLocked}
      bannerId={ctx.bannerId}
      setMLRstatus={ctx.setMLRstatus}
      MLRstatus={ctx.MLRstatus}
      damsID={ctx.damsID}
      isInfoPanel={ctx.isInfoPanel}
      showAssettype={ctx.showAssettype}
      selectedFontId={ctx.selectedFontId}
      setSelectedFontId={ctx.setSelectedFontId}
      updateSelctedFontstyle={ctx.updateSelctedFontstyle}
      setFroalatoolbarTag={ctx.setFroalatoolbarTag}
      genericInfo={ctx.genericInfo}
      setGenericInfo={ctx.setGenericInfo}
      myCanvasRef={ctx.myCanvasRef}
      animationObject={ctx.animationObject}
      setAnimationObject={ctx.setAnimationObject}
      dimensionsData={ctx.dimensionsData}
      selectedComponent={ctx.selectedComponent}
      setSelectedComponent={ctx.setSelectedComponent}
      isCustomScroll={!!ctx.editComponent}
      layerCompData={rhsLayerCompData}
      setLayerCompData={rhsSetLayerCompData}
      setCanvasStyleDraft={ctx.setCanvasStyleDraft}
      layerIndex={ctx.layerIndex}
      createFroalaInstance={ctx.createFroalaInstance}
      froalaIndex={ctx.froalaIndex}
      froalaFontAlignments={ctx.froalaFontAlignments}
      froalaNumberList={ctx.froalaNumberList}
      froalaFontStyles={ctx.froalaFontStyles}
      imageOnCanvas={ctx.imageOnCanvas}
      layerId={ctx.layerId}
      canvasDimension={ctx.canvasDimension}
      setCanvasDimension={ctx.setCanvasDimension}
      toggleSelected={ctx.toggleSelected}
      checkedAspect={ctx.checkedAspect}
      ToggleAspectLock={ctx.ToggleAspectLock}
      expanded={ctx.expanded}
      setExpanded={ctx.setExpanded}
      handleChange={ctx.handleChange}
      setCheckedScroll={ctx.setCheckedScroll}
      checkedScroll={ctx.checkedScroll}
      renderTheFontLink={ctx.renderTheFontLink}
      showBannertype={ctx.showBannertype}
      toggleAnimatedBanner={ctx.toggleAnimatedBanner}
      setSelectedPreviousId={ctx.setSelectedPreviousId}
      getEditSaveAssets={ctx.getEditSaveAssets}
      persistBannerCanvas={ctx.persistBannerCanvas}
      setShowBannerName={ctx.setShowBannerName}
      setundoFlag={ctx.setundoFlag}
      canvasUpdated={ctx.canvasUpdated}
      setCanvasUpdated={ctx.setCanvasUpdated}
      previousCanvasDimension={ctx.previousCanvasDimension}
      setPreviousCanvasDimension={ctx.setPreviousCanvasDimension}
      bgColorCanvas={ctx.bgColorCanvas}
      setBgColorCanvas={ctx.setBgColorCanvas}
      canvasBgChange={ctx.canvasBgChange}
      setCanvasBgChange={ctx.setCanvasBgChange}
      setOpenTimelinePopup={ctx.setOpenTimelinePopup}
      scrollBarExpand={ctx.scrollBarExpand}
      playPause={ctx.playPause}
      playPauseRef={ctx.playPauseRef}
      setClickedTimes={ctx.setClickedTimes}
      seconds={ctx.seconds}
    />
  );
};
